import { takeLatest, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { resolveError } from 'utils/resolveError';
import api from 'api/client';
import * as contract from 'reducer/rContract';

export function* sContract() {
    yield takeLatest(contract.fetchContractListRequest, fetchContractList);
}

function* fetchContractList(action) {
    try {
        // 파트너가 다른 번호를 보내면 서버가 자기 것으로 덮는다. 관리자는 비우면 전체다.
        const clientId = action.payload?.clientId;
        const response = yield call(() =>
            api.get('/contracts', { params: clientId ? { clientId } : {} }));

        if (response.data.resultCode === '0000') {
            yield put(contract.fetchContractListSuccess(response.data.data));
        } else {
            yield put(contract.fetchContractListFailure(
                resolveError(response.data)));
        }
    } catch (error) {
        yield put(contract.fetchContractListFailure(
            resolveError(error.response?.data)
            || i18next.t('common.unexpectedError')));
    }
}
